import { render, staticRenderFns } from "./paySecondOrder.vue?vue&type=template&id=5b30f2b2&scoped=true&"
import script from "./paySecondOrder.vue?vue&type=script&lang=js&"
export * from "./paySecondOrder.vue?vue&type=script&lang=js&"
import style0 from "./paySecondOrder.vue?vue&type=style&index=0&id=5b30f2b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30f2b2",
  null
  
)

export default component.exports